import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-datetime-cell-renderer',
    styleUrls: ['./datetime-cell-renderer.component.scss'],
    template: '<div class="datetime-wrapper">{{ datetime | date: "MM/dd/yyyy hh:mm:ss a" }}</div>',
    standalone: false,
})
export class DatetimeCellRendererComponent implements ICellRendererAngularComp {
    datetime: string | undefined;

    agInit(params: ICellRendererParams): void {
        this.datetime = this.getValue(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.datetime = this.getValue(params);
        return true;
    }

    private getValue(params: ICellRendererParams): string {
        return params.colDef?.field?.startsWith('udf_') ? params.value?.value : params.value;
    }
}
